// @flow

export const DEFAULT_TITLE = 'Create a new member';
